import { render, staticRenderFns } from "./ReqDocument.vue?vue&type=template&id=2a3f403d"
import script from "./ReqDocument.vue?vue&type=script&lang=js"
export * from "./ReqDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports